module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.invoice && _vm.page) ? _c('div', {
    staticClass: "thankyou-page"
  }, [_c('img', {
    staticClass: "img-responsive ma-auto",
    attrs: {
      "src": require("../../../../assets/img/gp-head-hbd@2x.png"),
      "width": "900px",
      "alt": "Celebrate"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("ขอบคุณสำหรับการบริจาค")]), _vm._v(" "), _c('h2', {
    staticClass: "text-center"
  }, [_vm._v("ที่ช่วยเพิ่มโอกาสทางการศึกษาแก่น้องๆ สำหรับการบริจาคและสร้างเพจในโอกาสพิเศษ")]), _vm._v(" "), _c('div', {
    staticClass: "block-white"
  }, [_c('div', {
    staticClass: "block-social-share"
  }, [_c('span', [_vm._v("ส่งต่อเพจระดมเงินของคุณให้เพื่อน")]), _vm._v(" "), _c('div', {
    staticClass: "group-share"
  }, [_c('vue-goodshare-facebook', {
    staticClass: "social-share-btn",
    attrs: {
      "page_url": _vm.pageUrl,
      "title_social": "Facebook",
      "has_icon": ""
    }
  }), _vm._v(" "), _c('share-line-button', {
    staticClass: "social-share-btn",
    attrs: {
      "page_url": _vm.pageUrl,
      "title_social": "LINE",
      "has_icon": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "share-email button-social"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$refs.shareEmailPopup.open()
      }
    }
  }, [_c('i', {
    staticClass: "far fa-envelope"
  }), _vm._v(" ส่ง e-card")])])], 1)]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "block-image-share"
  }, [_c('img', {
    attrs: {
      "src": _vm.page.share_image,
      "alt": "ThankYou Share"
    }
  })])])]), _vm._v(" "), (_vm.showUploadSlipForm) ? _c('div', [_vm._m(0)]) : _vm._e(), _vm._v(" "), (!_vm.showUploadSlipForm) ? _c('div', [_vm._m(1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('router-link', {
    staticClass: "btn btn--inline btn--white fs-sm",
    attrs: {
      "tag": "button",
      "to": ("/pages/" + (_vm.page.id)),
      "type": "button"
    }
  }, [_vm._v("เพจระดมเงินบริจาค")])], 1)])]) : _vm._e(), _vm._v(" "), _c('share-email-popup', {
    ref: "shareEmailPopup",
    attrs: {
      "page": _vm.page
    }
  }), _vm._v(" "), (_vm.showUploadSlipForm) ? _c('div', {
    staticClass: "show-uploadslip"
  }, [_c('upload-slip')], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center thankyou-remark"
  }, [_c('p', [_vm._v("อีกสักครู่ คุณจะได้รับอีเมลยืนยันการบริจาคจากทางเรา")]), _c('p', [_vm._v("หากบริจาคด้วยวิธีการโอนเงิน กรุณายืนยันการโอนเงิน จากแบบฟอร์มด้านล่าง หรือจากลิงก์แบบฟอร์มแจ้งโอนเงินในอีเมลที่ระบบส่งให้")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center thankyou-remark"
  }, [_c('p', [_vm._v("อีกสักครู่"), _c('br'), _vm._v("คุณจะได้รับอีเมลยืนยันการบริจาคจากทางเรา")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-145dcebc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/pages/special-events/thank-you.vue
// module id = 1112
// module chunks = 0